import React from 'react'
import DesiginationClient from './Designation'
import IndustryClient from './industry'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import RatingClient from './PerformanceRating'
import StatusClient from './Status'
import { UserCog, Users } from 'lucide-react'
import { HeadingWithIcon } from '../../../../../Components/Utils/Settingheading'

function ClientSettings() {
    return(
        <>
       
             <HeadingWithIcon icon={Users} title="Client" />
        
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <IndustryClient/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <DesiginationClient/>
         </div>
         {/* <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <RatingClient/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusClient/>
         </div> */}
        
       
         </div>
         </>
    )
}

export default ClientSettings
